const toShortYear = num => {
  return String(num).substr(2);
};

const get_fy_month = (fy_month, yearEnding) => {
  fy_month = fy_month.substr(0, 3);
  let prev_month = 'Mar';

  switch (fy_month) {
    case 'Jan':
      prev_month = 'Dec';
      break;
    case 'Feb':
      prev_month = 'Jan';
      break;
    case 'Mar':
      prev_month = 'Feb';
      break;
    case 'Apr':
      prev_month = 'Mar';
      break;
    case 'May':
      prev_month = 'Apr';
      break;
    case 'Jun':
      prev_month = 'May';
      break;
    case 'Jul':
      prev_month = 'Jun';
      break;
    case 'Aug':
      prev_month = 'Jul';
      break;
    case 'Sep':
      prev_month = 'Aug';
      break;
    case 'Oct':
      prev_month = 'Sep';
      break;
    case 'Nov':
      prev_month = 'Oct';
      break;
    case 'Dec':
      prev_month = 'Nov';
      break;
  }

  const offset = fy_month === 'Jan' ? 0 : 1;
  const year = `${fy_month} ${toShortYear(
    yearEnding - offset
  )} - ${prev_month} ${toShortYear(yearEnding)}`;

  return { fy_month, prev_month, year };
};

export default get_fy_month;
